import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import PlayersPage from 'components/events/players/players';
import PlayerVsBullPage from 'components/events/players/playerVsBull';
import { useAppPerformanceEventsListSelector } from '_common/hooks/selectors/eventSelector';
import { APPLICATION_NAME, CRYPTO_SECRET_KEY } from '_config';
import Cryptr from 'cryptr';

const cryptr = new Cryptr(CRYPTO_SECRET_KEY);

export default function OverUnderEventLeaderBoardContainer() {

    const perfEventsList = useAppPerformanceEventsListSelector()
    const { eventId } = useParams<any>()
    const [currentEvent, setCurrentEvent] = useState<any>()
  
    useEffect(() => {
      const eId = cryptr.decrypt(eventId)
      const event = perfEventsList?.find((e:any)=>e.id==eId)
      setCurrentEvent(event)
        const prevTitle = document.title
        document.title = `${APPLICATION_NAME} : Results`
        return () => {
            document.title = prevTitle
        }
    }, [])

    return (
        <React.Fragment>
            {/* <Sidebar page={RODEO_PAGE_NAME.LEADERBOARD} /> */}
            <section className="main-container">
            <div className="event-sec">
                <div className="container">
                {currentEvent?.pbr_enable==0 ? <PlayersPage /> : <PlayerVsBullPage />}
                {/* <PlayersPage1 /> */}
                </div>
            </div>
            </section>
        </React.Fragment>
    )
}
